// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"E2-z","displaySixCardTiles":"F2-z"};